import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-300 text-xs" />
            )}
            {item.href && index < items.length - 1 ? (
              <Link
                to={item.href}
                className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-700 font-medium' : 'text-foreground-400'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}